import React from 'react'
import {findDOMNode} from "react-dom"

import MenuSettingsAccount from "./account/account"
import MenuSettingsIntegrations from "./integrations/integrations"
import OrganizationSettings from "./organization-settings/organization-settings"
import MenuSearch_SettingsResults from "../../../search/search-results/menu-search-settings-results"
import CollapseState from "../../../../core/gd/manager/expand-collapse/collapse-state"
import NavigationSection from "../../../../core/model2/navigation/navigation-section"
import {NavigationSectionType} from "../../../../core/model2/navigation/@const"
import NavigationMenu_TopHeader from "../../components/top-header/top-header"
import {MenuComponentProps} from "../const"
import VScroll from "../../../../core/gd-components/scrolling/custom-v-scroll/v-scroll"
import MenuTopHeader_SearchActive from "../../components/top-header/search/search"
import {SpaceSettings} from "../../../../core/model2/space/system/settings"
import {MenuSpaceSearch} from "../../components/search/menu-space-search"
import MenuTopHeader_SearchButton from "../../components/top-header/search/search-button"

type State = {
    reRender    : boolean
}

export default class MenuSettings extends React.Component<MenuComponentProps, State> {

    public collapseState        : CollapseState
    private animationDelay      : any
    private animShow            : boolean = false
    public spaceSearch          : MenuSpaceSearch

    public navigationSection    : NavigationSection    = gd.navigationStructure.get(NavigationSectionType.SETTINGS)

    constructor(props: MenuComponentProps) {
        super(props);

        this.collapseState  = new CollapseState("settings-menu")
        this.collapseState.normalize(this.collapseState._readFromLocalStorage())

        this.spaceSearch    = new MenuSpaceSearch(new SpaceSettings(), this.reRender)

        this.state = {
            reRender: false
        }
    }

    componentDidMount() {

        //needed for animation
        this.animationDelay = _.delay(() => {
            this.animShow = true
            const dom = findDOMNode(this);
            gd.utils.Dom.addClass(dom, 'anim-show');
        }, 50);
    }

    componentWillUnmount() {
        clearTimeout(this.animationDelay)
    }

    onSectionToggle = (sectionName: string, isOpen: boolean) => {
        this.collapseState.toggle(sectionName)
        this.collapseState.save()
    }

    reRender = ()=> {
        this.setState({
            reRender: true
        });
    }

    render() {
        const classes = Classes('main-menu-container menu-settings ui5-menu hovered', {
            'animation': gd.layout.shouldAnimateMenu && !this.props.noAnimation,
            'anim-show': this.animShow
        });

        const rightButtonsClasses = Classes("flex-row-right-center", {
            "w-100-percent": this.spaceSearch.isActive
        })

        const isManager                  = gd.ac.check.company.isManager()
        const isSearchEnabled   = this.spaceSearch.searchValue.length !== 0

        return (
            <div className={classes}>
                {!this.spaceSearch.isActive &&
                    <NavigationMenu_TopHeader space={gd.spaces.settings}>
                        <div className={rightButtonsClasses}>
                            <MenuTopHeader_SearchButton className="m-r-15" spaceSearch={this.spaceSearch}/>
                        </div>
                    </NavigationMenu_TopHeader>
                }

                {this.spaceSearch.isActive &&
                    <div className="top-header flex-row-between-center">
                        <MenuTopHeader_SearchActive spaceSearch={this.spaceSearch}/>
                    </div>
                }

                <VScroll ref={this.props.refScroll} className="main-menu-scroll" mutationObserverEnabled={true}>

                    {isSearchEnabled && (
                        <MenuSearch_SettingsResults searchResult     = {this.spaceSearch.searchResults}
                                                   noResultsMessage = "No settings found in this space."/>
                    )}

                    {!isSearchEnabled &&
                        <>
                            {isManager &&
                                <OrganizationSettings collapseState     = {this.collapseState}
                                                      navigationSection = {this.navigationSection}
                                                      onToggle          = {this.onSectionToggle}/>
                            }
                            <MenuSettingsAccount collapseState      = {this.collapseState}
                                                 navigationSection  = {this.navigationSection}
                                                 onToggle           = {this.onSectionToggle}/>
                            <MenuSettingsIntegrations collapseState     = {this.collapseState}
                                                      navigationSection = {this.navigationSection}
                                                      onToggle          = {this.onSectionToggle}/>
                        </>
                    }
                </VScroll>
            </div>
        )
    }
}
